<template>
    <v-layout class="inner-pages" column>
      <v-flex pt-2 pb-3 class="sfh-login-header text-xs-center">
        <router-link class="d-flex ml-1 router-link-active" to="/">
          <img
            :src="appIcon"
            height="70" width="70" alt="SFH Logo">
        </router-link>
        <h2 class="white--text font-weight-regular line-height-1"><span v-text="appName"/>
          <br><small class="font-weight-medium">Forgot Password</small>
        </h2>
      </v-flex>
      <v-flex pt-5 px-5 pb-0 class="sfh-login-form background-image">
          <v-flex class="green--text text-xs-center" v-show="disabled === true">
            We just sent a 4 digit code to <strong class="text-primary">{{ username }}</strong>.</v-flex>

        <v-text-field
          prepend-icon="person"
          v-validate="'required|email'"
          v-model="username"
          :error-messages="errors.collect('slot1.username')"
          label="Email"
          data-vv-name="slot1.username"
          data-vv-scope="slot1"
          :disabled="disabled"
          type="email"
        ></v-text-field>

        <v-text-field
          v-show="disabled === true"
          :append-icon="e1 ? 'visibility' : 'visibility_off'"
          @click:append="() => (e1 = !e1)"
          :type="e1 ? 'password' : 'text'"
          v-validate="'required'" prepend-icon="lock"
          v-model="password"
          label="New Password"
          data-vv-name="slot2.password"
          data-vv-scope="slot2"
          :error-messages="errors.collect('slot2.password')"
        ></v-text-field>

        <v-text-field
          prepend-icon="arrow_right_alt"
          v-show="disabled === true"
          v-validate="'required|length:4'"
          :error-messages="errors.collect('slot2.otp')"
          data-vv-name="slot2.otp"
          data-vv-scope="slot2"
          v-model="otp"
          label="Code"
          :type="'number'"
        ></v-text-field>

        <v-spacer></v-spacer>
        <v-btn v-show="disabled === false" :loading="loading" block color="primary"
               @click.prevent="sendOtp">Send verification code</v-btn>

        <v-btn v-show="disabled === true"  :loading="loading" color="primary" block
               @click.prevent="resetPassword">Reset Password</v-btn>

        <v-flex d-flex  align-center xs12  class="text-xs-right mt-3">
          <v-layout>
            <v-flex align-center xs7 class="text-xs-right mt-3 pr-1">
              <em>Can't find our email?<br>Remember to check spam or junk email folders.</em>
            </v-flex>

            <v-flex xs5 class="text-xs-left">
              <img
                alt="folder"
                src="static/images/folder-100x100.png" />
            </v-flex>
          </v-layout>

        </v-flex>
      </v-flex>
      <v-dialog v-model="dialog" persistent :width="$store.getters.getAppWidth - 10">
        <v-card>
          <v-card-title  class="headline"><v-icon color="success">done</v-icon> &nbsp;Success</v-card-title>
          <v-divider class="mt-0"></v-divider>
          <v-card-text>
            <p>Your password has been changed successfully.</p>
            <p>Please Sign In to continue.</p>
          </v-card-text>
          <v-divider class="mb-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" to="/login" @click.native="dialog = false">Sign In</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>

</template>

<script>
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  Vue.use(VeeValidate)
  export default {
    name: 'ForgotPassword',
    data: () => ({
      appIcon: require('@/assets/logos/' + process.env.APP_ICON),
      appName: process.env.APP_NAME,
      loading: false,
      username: '',
      password: '',
      otp: '',
      otpId: '',
      otpRefNumber: '',
      disabled: false,
      apiUrl: process.env.API_URL,
      e1: true,
      dialog: false,
      dictionary: {
        custom: {
          'slot1.username': {
            required: () => 'Email is required',
            email: () => 'Please enter valid email id'
          },
          'slot2.password': {
            required: () => 'Password is required'
          },
          'slot2.otp': {
            required: () => 'Please enter 4 digit code',
            length: 'Code must be 4 Digits'
          }
        }
      }
    }),
    mounted () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      resetPassword () {
        this.$validator.validateAll('slot2').then((result) => {
          if (result) {
            this.loading = true
            this.$http({
              url: this.apiUrl + '/ws/userservice/password/change',
              method: 'POST',
              data: {
                'email': this.username,
                'otpId': this.otpId,
                'enteredOtp': this.otp,
                'newPassword': this.password
              }
            }).then((res) => {
              this.loading = false
              this.dialog = true
            }, (err) => {
              this.loading = false
              console.log('error found', err)
              this.errors.add({
                scope: 'slot2',
                field: 'otp',
                msg: 'Invalid code'
              })
            }).catch((e) => {
              this.loading = false
              console.log('Caught', e)
            })
          } else {
            this.loading = false
          }
        })
      },
      sendOtp () {
        this.errors.clear('slot1')
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            this.loading = true
            this.$http({
              url: this.apiUrl + '/ws/userservice/request/otp/pwreset/' + this.username,
              method: 'GET'
            }).then((res) => {
              this.loading = false
              this.disabled = true
              this.otpId = res.data.otpId
              this.otpRefNumber = res.data.otpRefNumber
              // this.$router.push({name: 'CodeVerification', params: {email: encryptedEmail, otp_id: res.data.otpId}})
            }, (err) => {
              this.loading = false
              console.log('error found', err)
              this.errors.add({
                scope: 'slot1',
                field: 'username',
                msg: 'Invalid email address'
              })
            }).catch((e) => {
              this.loading = false
              console.log('Caught', e)
              this.errors.add({
                scope: 'slot1',
                field: 'username',
                msg: 'Invalid email address'
              })
            })
          }
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/auth/ForgotPassword.vue